import { connect } from 'react-redux';
import { denormalize } from 'normalizr';
import { schema } from '../../../../../state/schema';
import { loadCareGuidePartnerTags } from '../../../../../state/modules/careGuidePartnerTags/actions';
import CareGuidePartnerTagInput from '../components/CareGuidePartnerTagInput';

const defaultLimit = 10;
const defaultOrder = 'id.asc';

const mapStateToProps = (state, ownProps) => {
  // merge results for all modules
  const results = [].concat.apply(
    [],
    Object.entries(
      state.careGuidePartnerTags.getIn(
        ['pages', defaultOrder, defaultLimit],
        {}
      )
    ).map(([k, v]) => v.toArray())
  );

  const list =
    results.length > 0
      ? results.map((x) => {
          return {
            key: x,
            ...denormalize(
              state.entities.getIn(['careGuidePartnerTags', x]),
              schema.careGuidePartnerTag,
              state.entities.toJS()
            ),
          };
        })
      : [];
  return {
    options: list,
    isLoading: state.careGuidePartnerTags.get('isLoading'),
    defaultLimit,
    defaultOrder,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    load: (
      page = 1,
      limit = defaultLimit,
      order = defaultOrder,
      filter = {},
      cb = function () {}
    ) => {
      dispatch(
        loadCareGuidePartnerTags(
          page,
          limit,
          order,
          filter,
          (success, total) => {
            if (success) {
              // loop over all pages to get all events
              const pageCount = Math.ceil(total / limit);
              for (var i = 2; i <= pageCount; i++) {
                dispatch(loadCareGuidePartnerTags(i, limit, order, filter));
              }
              cb();
            }
          }
        )
      );
    },
  };
};

const CareGuidePartnerTagInputContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(CareGuidePartnerTagInput);

export default CareGuidePartnerTagInputContainer;
